import { render } from "./CloseWebsiteButton.vue?vue&type=template&id=30353dcd&scoped=true"
import script from "./CloseWebsiteButton.vue?vue&type=script&lang=js"
export * from "./CloseWebsiteButton.vue?vue&type=script&lang=js"

import "./CloseWebsiteButton.vue?vue&type=style&index=0&id=30353dcd&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30353dcd"]])

export default __exports__